const twoFactorFormConstantsEN = {
  verficationTitle: 'Verification',
  verficationEnterCode: 'Enter the 6 digit security code sent to your registered email',
  verficationExpiry: 'Please note that the code will expire in 30 minutes',
  verficationButtonText: 'Verify',
  resendCode: 'Resend',
  noCodeLabel: "Didn't receive the code? ",
  noEmailLabel: "Didn't receive the email?",
  backToLogin: 'Back to login',
};

export default twoFactorFormConstantsEN;
